import React from "react";

export default class NumberInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="NumberInput">
        {this.props.icon}
        <input
          type="number"
          {...this.props}
          className={"form-control " + (this.props.icon ? " has-icon" : "")}
        />
      </div>
    );
  }
}
